import { combineReducers } from "redux";
import feedback from "../features/admin/rating_and_feedback/feedback/Slice";

const rating_and_feedback = combineReducers({
  feedback: feedback,
});

export default rating_and_feedback;
